export const error_message = {
    0: '操作成功',
    3: '请求非法（非json格式）',
    996: '管理员没有登录',
    2: '内部错误',
    10: 'id不合法',
    11: '身份证号不合法',
    13: '描述不合法',
    14: '名字不合法',
    22: '时间不合法',
    26: '金额不合法',
    25: '已经存在了',
    28: '手机号不合法',
    30: '列表不合法',
    34: '天数不合法',
    37: '附加信息不合法',
    38: '日期不合法',
    42: '流水号不合法',
    44: '渠道不合法',
    60: 'QQ号不合法',
    61: 'Email不合法',
    62: '地址不合法',
    63: '固定电话不合法',
    64: '关系不合法',
    // 72: 'token不合法',
    72: '请登录', //修改提示
    73: 'URL不合法',
    74: '订单号不合法',
    // basic
    17: 'Range不合法',
    18: '状态不合法',
    23: '执照号不合法',
    35: '已经认证过了',
    43: '数据不合法',
    45: '信息不合法',
    46: 'ID Range不合法',
    48: '企业名不合法',
    50: '金额不足',
    51: '操作不合法',
    71: '签名不合法',
    75: '密码不对',
    76: '用户不存在',
    77: '用户被冻结',
    78: '验证码错误',
    79: '用户id号错误',

    // user
    90: '用户余额不足',
    // site
    100: '分站id号错误',

    // product
    120: '商品ID号错误',
    121: '商品数量错误',


    122: 'AppID不合法',
    123: 'AppSecret不合法',
    124: '认证信息出错',

    // order
    130: '收货人信息有误',
    131: '购物车为空',
    132: '订单状态有误',
    133: '订单状态有误',
    134: '订单取消失败',

    135: '无效的仓库ID',
    137: '省份不合法',
    138: '城市不合法',
    139: '地区不合法',


    // external
    200: '认证失败',
    201: '站点冻结中，请联系管理员',
    202: '商品ID不合法',
    203: '仓库ID不合法',
    204: '商品数量不合法',
    205: '收货人信息不合法',
    206: '订单来源不合法',
    207: '订单号不合法',
    208: '取消订单失败，请联系客服',
    209: '账户余额不足，请充值。',
    210: '未知错误，请联系客服',
    10012: '手机号不合法',
    10015: 'Filter不合法',
    10016: 'Sort不合法',
    10021: '登录失败次数太多',
    10027: '类型不合法',
    10029: '新密码不合法',
    10031: '管理员角色重复',
    10032: '计划不合法',
    10036: '认证失败',
    10039: '命令不合法',
    10040: '原因不合法',
    10041: '前端数据不合法',
    10047: '数字不合法',
    10049: '营业执照号冲突',
    10052: 'req_id不合法',
    10053: '利率不合法',
    10054: '秀品街余额不足'
}